function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React, { memo } from 'react';
import './index.scss';
const Placeholder = /*#__PURE__*/memo(({
  loading,
  noMargin,
  slant,
  animated,
  className,
  children,
  ...props
}) => {
  return loading ? /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames("skeleton-placeholder", {
      'no-margin': noMargin,
      slant,
      animated
    }, className)
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
});
Placeholder.defaultProps = {
  loading: true,
  animated: true
};
export default Placeholder;